<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 26 26"
    preserveAspectRatio="xMinYMin meet"
    class="icon"
  >
    <g>
      <path
        d="M 10.5 0.15625 C 7.483 0.15625 5.0625 2.2285 5.0625 6.1875 C 5.0625 8.7735 6.09225 11.40825 7.65625 13.03125 C 8.26525 14.65425 7.1665 15.25775 6.9375 15.34375 C 3.7815 16.50175 0.09375 18.6015 0.09375 20.6875 L 0.09375 21.46875 C 0.09375 24.31075 5.50825 24.96875 10.53125 24.96875 C 11.63325 24.96875 12.7395 24.92175 13.8125 24.84375 C 12.4935 23.44375 11.6875 21.574 11.6875 19.5 C 11.6875 17.709 12.2975 16.068 13.3125 14.75 C 13.1615 14.398 13.102 13.843 13.375 13 C 14.93 11.375 15.9375 8.7635 15.9375 6.1875 C 15.9375 2.2285 13.514 0.15625 10.5 0.15625 z M 19.5 13.1875 C 16.014 13.1875 13.1875 16.013 13.1875 19.5 C 13.1875 22.987 16.013 25.8125 19.5 25.8125 C 22.987 25.8125 25.8125 22.987 25.8125 19.5 C 25.8125 16.013 22.986 13.1875 19.5 13.1875 z M 18.625 16 L 20.375 16 L 20.375 18.59375 L 22.96875 18.59375 L 22.96875 20.40625 L 20.375 20.40625 L 20.375 23 L 18.625 23 L 18.625 20.40625 L 16 20.40625 L 16 18.59375 L 18.625 18.59375 L 18.625 16 z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "queue"
};
</script>
<style scoped>
.icon {
  fill: currentColor;
}
</style>
